import React from "react";
import "./sink-card.scss";


function SinkCard(props) {
return (

  
<a href={"/sinks/" + props.data.url} className="sink-card">
        
    <><img src={props.data.imageurl} alt={props.data.altText} />
    <h3>{props.data.productName}</h3>
 </>

</a>
);
}

export default SinkCard;